import { useEffect, useRef } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { TimeAgo } from '../../helpers/utility';
import AttachmentContainer from '../../pages/groupChat/attachmentContainer';
import { AppointmentRequestMessage } from '../messageTypes/appointmentRequestMessage';
import { ApptMessage } from '../messageTypes/apptMessage';
import { ChangeRequestMessage } from '../messageTypes/changeRequestMessage';
import { EventMessage } from '../messageTypes/eventMessage';
import { ReferralRequestMessage } from '../messageTypes/referralRequestMessage';
import { VezoSessionMessage } from '../messageTypes/vezoSessionMessage';


const PushdownMenu = ({
  isLoading,
  suggestions,
  onSelected,
}) => {


    if (isLoading) {
        return (
        <div className="absolute top-10 right-0 left-0 z-20 rounded-b-lg shadow-lg bg-white p-4 flex items-center justify-center">
            <FaSpinner  className='animate-spin'/>
        </div>
        )
    }

    const dummyLoggedInUserFun = () => null

    const RelatedMessage = ({msg}) => {
        
        if(msg.message?.event_type == 'referral_requested'){
            return <ReferralRequestMessage msg={msg} isLoggedInUser={dummyLoggedInUserFun} />
        }
        else if(msg.message?.event_type == 'note_signed'){
            return <EventMessage msg={msg} isLoggedInUser={dummyLoggedInUserFun} />
        }
        else if(msg.message?.event_type == 'request_appointment'){
            return <AppointmentRequestMessage msg={msg} isLoggedInUser={dummyLoggedInUserFun} />
        }
        else if(msg.message?.event_type == 'appointment'){
            return <ApptMessage msg={msg} isLoggedInUser={dummyLoggedInUserFun} />
        }
        else if(msg.message?.event_type == 'vezo_session'){
            return <VezoSessionMessage msg={msg} isLoggedInUser={dummyLoggedInUserFun} />
        }
        else if(msg.message?.event_type == 'change_status'){
            return <ChangeRequestMessage msg={msg} isLoggedInUser={dummyLoggedInUserFun} />
        }

        return (
            <div>
                <div className='flex justify-start'>{msg.message.text}</div>
                {msg.message.media?.length ?
                    <div className="mt-2">
                        <AttachmentContainer data={{files: msg.message?.media}} openInEditor="false" />
                    </div>
                    : null
                }
            </div>
        )
    }

    return !suggestions?.length ? (
        <></>
      ) : (
        <div className="absolute top-10 right-0 left-0 z-20 border-[1px] rounded-lg shadow-lg bg-white p-2 max-h-[450px] overflow-y-auto">
            {suggestions.map((msg) => {
                return (
                    <div key={msg.id}>
                        <p className="text-sm font-medium text-gray-900 flex justify-start pl-1">
                            {msg.sender} 
                            <span className="text-xs text-gray-500 ml-1">{msg.created ? <TimeAgo date={new Date(msg.created)} /> : null }</span>
                        </p>
                        <div className="p-2 mb-3 border-[1px] font-medium flex justify-start text-opacity-50 rounded-lg bg-gray-100 hover:bg-gray-200 w-full cursor-pointer" onClick={()=>onSelected(msg)}>
                            <RelatedMessage msg={msg} />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default PushdownMenu
